import { ApiEventStatus } from 'src/WebApiController';

export enum StatusColor {
  Red = 'red',
  Yellow = 'yellow',
  Gray = 'gray',
}

export const EventStatusToColor: Readonly<Record<ApiEventStatus, StatusColor>> =
  {
    [ApiEventStatus.Cancelled]: StatusColor.Red,
    [ApiEventStatus.Deleted]: StatusColor.Red,
    [ApiEventStatus.Draft]: StatusColor.Gray,
    [ApiEventStatus.Normal]: StatusColor.Gray,
    [ApiEventStatus.Contingent]: StatusColor.Yellow,
    [ApiEventStatus.Postponed]: StatusColor.Yellow,
    [ApiEventStatus.Relocated]: StatusColor.Yellow,
    [ApiEventStatus.Rescheduled]: StatusColor.Yellow,
    [ApiEventStatus.RelocatedAndRescheduled]: StatusColor.Yellow,
  };

export interface EventStatusProps {
  status: ApiEventStatus | null | undefined;
}
